import { booleanPointInPolygon } from '@turf/turf';
import { toLonLatArray } from '@utils/validation/coordinates.utils';

import { Target } from '@/types/c2/c2.types';
import { TargetLocation } from '@/types/sensor/sensor.types';
import { AbstractFlightPlan } from '@/types/utm/flightPlan.types';

export default function getOutsideOfFlightPlansDrones(
  drones: Target<TargetLocation>[],
  flightPlans: AbstractFlightPlan[],
): { [key: string]: { drone: Target<TargetLocation>; flightPlans: AbstractFlightPlan[] } } {
  return drones.reduce(
    (acc, drone) => {
      const droneFlightPlans = flightPlans.filter((flightPlan) => drone.fpCodes.includes(flightPlan.code));
      //If the flightplan list is empty, the drone as no location or the drone is in at least one flight plan
      // we don't need a link so we ignore this drone
      if (
        droneFlightPlans.length === 0 ||
        drone.lastPosition.location === null ||
        droneFlightPlans.some((flightPlan) =>
          booleanPointInPolygon(toLonLatArray(drone.lastPosition.location!.position, false)!, flightPlan.polygons),
        )
      ) {
        return acc;
      }
      return { ...acc, [drone.id]: { drone, flightPlans: droneFlightPlans } };
    },
    {} as { [key: string]: { drone: Target<TargetLocation>; flightPlans: AbstractFlightPlan[] } },
  );
}
